export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10352.647dea82.jpg";